<script>
    export default {
        name: "PushBanner",
    }
</script>

<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import push-banner
</style>


